import { VariantProps } from 'class-variance-authority'
import { createContext } from 'react'
import { buttonVariants } from './button-variants'

export type ButtonGroupContextType = VariantProps<typeof buttonVariants> & { disabled?: boolean }

export const ButtonGroupContext = createContext<ButtonGroupContextType>({})
